import { isFlowTheme } from 'src/Libs/utils'

const FLOW_DATA_SECURITY_LINK = 'https://hager.com/_de/privacy/products-services/flow'
const FLOW_DATA_SECURITY_EMAIL = 'info@hager.de'

export const DATA_SECURITY_LINK = isFlowTheme ? FLOW_DATA_SECURITY_LINK : '/privacy-protection'
export const DATA_SECURITY_EMAIL = isFlowTheme ? FLOW_DATA_SECURITY_EMAIL : 'datenschutzbeauftragter@e3dc.com'

export const SHOWROOM_LINK = 'https://www.e3dc.com/unternehmen/showroom/#Intro'
export const SHOWROOM_WORD_IN_ALL_TRANSLATIONS = 'showroom'

export const USER_CHANGE_EMAIL_CONFIRMATION_LINK = 'user/email-change-confirmation'
